import * as React from 'react';
import { Component } from 'react';
import { IPlace } from '../../models/IPlace';
import { IAdvancedSearchItem } from '../../models/IAdvancedSearchItem';
import { IViewport } from '../../models/IViewport';
import { ILocalization } from '../../models/ILocalization';
import { Redirect } from 'react-router';
import { baseUrl } from '../..';
import { ICoordinates } from '../../models/ICoordinates';
import { IMarkerLocalization } from '../../models/IMarkerLocalization';
import { MAP_STYLES } from '../../constants/MapConsts';

interface IInfoWindow {
    Event: () => void,
    Id: string
}

interface IProps {
    Place: IPlace,
    ResultItems: IAdvancedSearchItem[],
    OnViewPortChanged: (viewport: IViewport, viewportChangedByNewProps: boolean) => void
}

interface IState {
    RedirectToViewId?: string
}

export class MapResultComponent extends Component<IProps, IState> {

    private mapRef = React.createRef<HTMLDivElement>();
    private map?: google.maps.Map = undefined;
    private markers: any[] = [];
    private circles: any[] = [];
    private apiReadyId: number = 0;
    private preventDataRefresh = false;
    private lastViewPort?: IViewport;
    private viewportChangedByNewProps = false;

    constructor(props) {
        super(props);

        this.state = {
            RedirectToViewId: undefined
        };

        this.OnPhysiotherapistNameClick = this.OnPhysiotherapistNameClick.bind(this);
        this.CloseAllInfoWindows = this.CloseAllInfoWindows.bind(this);
        this.OpenInfoWindow = this.OpenInfoWindow.bind(this);
        this.OnBoundsChanged = this.OnBoundsChanged.bind(this);
        this.TriggerViewportChange = this.TriggerViewportChange.bind(this);
        this.MapFitBounds = this.MapFitBounds.bind(this);
    }

    public componentDidMount() {
        if ((window as any).google === undefined) {
            this.apiReadyId = (window as any).RegisterGoogleApiReady(this.InitializeMap.bind(this));
        }
        else {
            this.InitializeMap();
        }
        this.componentWillReceiveProps(this.props);
    }

    public componentWillUnmount() {
        (window as any).DeregisterGoogleApiReady(this.apiReadyId);
    }

    public componentWillReceiveProps(newProps: IProps) {
        if (this.map) {
            if (newProps.Place.location !== undefined && newProps.Place.viewport !== undefined) {
                let currentBounds = this.map.getBounds();
                if (currentBounds) {
                    if (newProps.Place.useOnlyViewportForSearch === false &&
                        (
                            currentBounds.getNorthEast().lat() !== newProps.Place.viewport.northeast.lat ||
                            currentBounds.getNorthEast().lng() !== newProps.Place.viewport.northeast.lng ||
                            currentBounds.getSouthWest().lat() !== newProps.Place.viewport.southwest.lat ||
                            currentBounds.getSouthWest().lng() !== newProps.Place.viewport.southwest.lng
                        )
                    ) {
                        this.MapFitBounds(newProps.Place.location, newProps.Place.viewport);
                    }
                } else {
                    this.MapFitBounds(newProps.Place.location, newProps.Place.viewport);
                }
            }
            this.createMarkers(newProps);
        } else {
            this.createMap(newProps.Place);
        }
    }

    public OpenInfoWindow(physiotherapistId: string, clinicId: number) {
        if (this.map !== undefined) {
            let bounds = this.map.getBounds();
            console.log(this.circles)
            if (bounds) {
                for (let marker of this.markers) {
                    if ((marker.clinicIds as number[]).indexOf(clinicId) !== -1) {
                        for (let id of marker.ids) {
                            if (id.Id === physiotherapistId) {
                                this.CloseAllInfoWindows();
                                this.OpenMarkerInfoWindow(marker);
                            }
                        }
                    }
                }
            }
        }
    }

    public render() {
        return (
            <div ref={this.mapRef} className="advanced-search-map" >
                {this.RenderRedirectToView()}
            </div>
        );
    }

    private RenderRedirectToView() {
        if (this.state.RedirectToViewId !== undefined) {
            return (
                <Redirect to={'/fizjoterapeuta/' + this.state.RedirectToViewId} push={true} />
            );
        } else {
            return null;
        }
    }

    private ZoomViewport(location: ICoordinates, viewport: IViewport, zoomPercentage: number): IViewport {
        if (zoomPercentage <= 0 && zoomPercentage >= 100) {
            return viewport;
        }
        let distanceLat = viewport.northeast.lat - viewport.southwest.lat;
        let distanceLng = viewport.northeast.lng - viewport.southwest.lng;
        let distanceDiffLat = ((distanceLat / 2) * (zoomPercentage / 100));
        let distanceDiffLng = ((distanceLng / 2) * (zoomPercentage / 100));
        let result: IViewport = {
            northeast: {
                lat: location.lat + distanceDiffLat,
                lng: location.lng + distanceDiffLng
            },
            southwest: {
                lat: location.lat - distanceDiffLat,
                lng: location.lng - distanceDiffLng
            },
        }
        return result;
    }

    private InitializeMap() {
        if ((window as any).google) {
            if (this.props.Place.location !== undefined) {
                this.createMap(this.props.Place);
            }
        }
    }

    private createMap(place?: IPlace) {
        if (!(window as any).google) {
            return;
        }
        if (place === undefined) {
            return;
        }
        if (place.location === undefined) {
            return;
        }
        this.viewportChangedByNewProps = true;
        this.map = new google.maps.Map(this.mapRef.current, {
            center: { lat: place.location.lat, lng: place.location.lng },
            zoom: 10,
            mapTypeControl: false,
            styles: MAP_STYLES
        });

        if (this.map !== undefined) {
            this.map.addListener('bounds_changed', this.OnBoundsChanged);
        }
    }

    private OnBoundsChanged() {
        let bounds = (this.map as any).getBounds();
        let newViewPort: IViewport = {
            northeast: {
                lat: bounds.getNorthEast().lat(),
                lng: bounds.getNorthEast().lng()
            },
            southwest: {
                lat: bounds.getSouthWest().lat(),
                lng: bounds.getSouthWest().lng()
            },
        };

        let treshold = 0.15;

        if (this.lastViewPort) {
            if ((Math.abs(this.lastViewPort.northeast.lat - newViewPort.northeast.lat) / Math.abs(this.lastViewPort.northeast.lat - this.lastViewPort.southwest.lat)) > treshold ||
                (Math.abs(this.lastViewPort.northeast.lng - newViewPort.northeast.lng) / Math.abs(this.lastViewPort.northeast.lng - this.lastViewPort.southwest.lng)) > treshold
            ) {
                this.TriggerViewportChange(newViewPort);
            } else {
                console.log('OnBoundsChanged: under treshold');
            }
        } else {
            this.TriggerViewportChange(newViewPort);
        }
    }

    private TriggerViewportChange(newViewPort: IViewport) {
        if (this.preventDataRefresh === false) {
            this.lastViewPort = newViewPort;
            this.props.OnViewPortChanged(newViewPort, this.viewportChangedByNewProps);
        } else {
            this.preventDataRefresh = false;
        }
        this.viewportChangedByNewProps = false;
    }

    private getInfoHtml(imageUrl: string, name: string, clinic: string, address: string, id: string) {
        return `<div id="physioDetail_${id}" style="background-image:url('${imageUrl}');" class="map-info-window-row"><p class="map-info-window-name">${name}</p><span class="map-info-window-place">${clinic}</span><br/><span class="map-info-window-place">${address}</span></div>`;
    }

    private createMarkers(newProps: IProps) {
        if (newProps.ResultItems.length > 0) {
            let allMarkers: any[] = [];
            let allCircles: any[] = [];
            let newLocalizations: IMarkerLocalization[] = [];
            for (let item of newProps.ResultItems) {
                if (item.LocationData) {
                    for (let clinicLocalization of item.LocationData as ILocalization[]) {
                        if (clinicLocalization.id === undefined || clinicLocalization.id === -1) {
                            continue;
                        }
                        let found: boolean = false;
                        for (let nL of newLocalizations) {

                            if (nL.Lat === clinicLocalization.lat && nL.Lng === clinicLocalization.lng) {
                                found = true;
                                nL.ClinicIds.push(clinicLocalization.id);
                                break;
                            }
                        }
                        if (found === true) {
                            continue;
                        }
                        const foundClinic = item.Clinics.find(clinic => clinic.Id === clinicLocalization.id)
                        newLocalizations.push({
                            Lat: clinicLocalization.lat,
                            Lng: clinicLocalization.lng,
                            ClinicIds: [clinicLocalization.id],
                            IsHomeService: foundClinic ? foundClinic.IsHomeService : false,
                            HomeServiceScope: foundClinic ? foundClinic.HomeServiceScope : 0
                        });
                    }
                }
            }

            //Tu jest "zdejmowanie" niepotrzebnych markerów z mapy:
            for (let marker of this.markers) {
                let found: boolean = false;
                let markerPosition = marker.get('position') as google.maps.LatLng;
                for (let localization of newLocalizations) {
                    if (localization.Lat === markerPosition.lat() && localization.Lng === markerPosition.lng()) {
                        found = true;
                        allMarkers.push(marker);
                        break;
                    }
                }
                if (found === false) {
                    marker.setMap(null);
                }
            }

            for (let circle of this.circles) {
                let found: boolean = false;
                let center = circle.get('center') as google.maps.LatLng;
                for (let localization of newLocalizations) {
                    if (localization.Lat === center.lat() && localization.Lng === center.lng()) {
                        found = true;
                        allCircles.push(circle);
                        break;
                    }
                }
                if (found === false) {
                    circle.setMap(null);
                }
            }

            for (let localization of newLocalizations) {
                let found: boolean = false;
                for (let marker of allMarkers) {
                    let markerPosition = marker.get('position') as google.maps.LatLng;
                    if (markerPosition.lat() === localization.Lat && markerPosition.lng() === localization.Lng) {
                        found = true;
                        for (let clinicId of localization.ClinicIds) {
                            let markerClinicIds = marker.get('clinicIds') as number[];
                            if (markerClinicIds.find((id) => (id === clinicId)) === undefined) {
                                markerClinicIds.push(clinicId)
                            }
                        }
                    }
                }
                if (found === true) {
                    continue;
                }

                let newMarker: any = new google.maps.Marker({
                    position: new (window as any).google.maps.LatLng(localization.Lat, localization.Lng),
                    map: this.map,
                    clinicIds: [...localization.ClinicIds], //clone array
                    listener: null,
                    icon: baseUrl + "images/marker.svg",
                    animation: (window as any).google.maps.Animation.BOUNCE
                } as any);

                if (localization.IsHomeService && localization.HomeServiceScope) {

                    const cityCircle = new google.maps.Circle({
                        strokeColor: "#ff7165",
                        strokeOpacity: 0.4,
                        strokeWeight: 1,
                        fillColor: "#ff7165",
                        fillOpacity: 0.06,
                        map: this.map,
                        center: new (window as any).google.maps.LatLng(localization.Lat, localization.Lng),
                        radius: localization.HomeServiceScope * 1000
                    });
                    allCircles.push(cityCircle);
                    if (this.map) {
                        this.map.setZoom(8);
                    }
                }

                newMarker.setAnimation(4);
                allMarkers.push(newMarker);
            }

            for (let point of allMarkers) {
                if (point.get('listener') !== null) {
                    (window as any).google.maps.event.removeListener(point.get('listener'));
                }

                //let infowindow: any = new (window as any).google.maps.InfoWindow({ disableAutoPan: true });
                let infowindow: any = new (window as any).google.maps.InfoWindow();
                let text: string = "";
                let ids: IInfoWindow[] = [];
                point.ids = ids;
                point.text = text;

                for (let item of newProps.ResultItems) {
                    for (let clinic of item.Clinics) {
                        if ((point.get('clinicIds') as number[]).indexOf(clinic.Id) !== -1) {
                            point.text += this.getInfoHtml(item.BasicInfo.ProfileImgUrl != null ? item.BasicInfo.ProfileImgUrl : "/images/default_profile_pic.svg",
                                item.BasicInfo.FirstName + " " + item.BasicInfo.LastName,
                                clinic.FullName,
                                clinic.FullAddress,
                                item.BasicInfo.Id);

                            point.ids.push(
                                {
                                    Event: () => {
                                        this.OnPhysiotherapistNameClick(item.BasicInfo.Id);
                                    },
                                    Id: item.BasicInfo.Id
                                } as IInfoWindow
                            );
                            if (point.infowindow === undefined) {
                                point.infowindow = infowindow;
                            }
                        };
                    }
                }
                let listener = (window as any).google.maps.event.addListener(point, 'click', this.OpenInfoWindowOnClick.bind(this, point));
                point.listener = listener;
            }
            this.markers = allMarkers;
            this.circles = allCircles;
        } else {
            //Tu jest "zdejmowanie" niepotrzebnych markerów z mapy:
            for (let marker of this.markers) {
                marker.setMap(null);
            }

            for (let circle of this.circles) {
                circle.setMap(null);
            }
            this.circles = [];
        }
    }

    private OpenInfoWindowOnClick(point) {
        this.preventDataRefresh = true;
        this.CloseAllInfoWindows();
        if (point.infowindow !== undefined && point.text !== "") {
            point.infowindow.setContent(point.text);
            point.infowindow.addListener('domready', () => {
                for (let id of point.ids) {
                    let details = document.getElementById("physioDetail_" + id.Id);
                    if (details) {
                        details.addEventListener('click', id.Event);
                    }
                }
            });
            point.infowindow.open(point.map, point);
        }
    }

    private CloseAllInfoWindows() {
        for (let marker of this.markers) {
            if (marker.infowindow) {
                marker.infowindow.close(marker.map, marker);
            }
        }
    }

    private OpenMarkerInfoWindow(marker) {
        this.preventDataRefresh = true;
        if (marker.infowindow) {
            marker.infowindow.setContent(marker.text);
            marker.infowindow.addListener('domready', () => {
                for (let id of marker.ids) {
                    let details = document.getElementById("physioDetail_" + id.Id);
                    if (details) {
                        details.addEventListener('click', id.Event);
                    }
                }
            });
            marker.infowindow.open(marker.map, marker);
        }
    }

    private OnPhysiotherapistNameClick(id: string) {

        this.setState({
            RedirectToViewId: id
        });
    }

    private MapFitBounds(newLocation: ICoordinates, newViewport: IViewport) {
        if (this.map) {

            // let prevBounds = this.map.getBounds();
            let zoomedViewport = this.ZoomViewport(newLocation, newViewport, 65);
            let bounds = new google.maps.LatLngBounds();
            bounds.extend(new google.maps.LatLng(zoomedViewport.southwest.lat, zoomedViewport.southwest.lng));
            bounds.extend(new google.maps.LatLng(zoomedViewport.northeast.lat, zoomedViewport.northeast.lng));
            this.viewportChangedByNewProps = true;
            this.map.fitBounds(bounds);
            // let newBounds = this.map.getBounds();
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/Search/MapResultComponent.tsx